import { Button, Divider, Stack, TextField } from "@mui/material";
import { useState } from "react";
import { useBinanceOptionsSecuredDataService } from "./hooks/binance-options-data-service/useBinanceOptionsSecuredDataService";
import { NumberFormatOptions, numberFormatters } from "../shared/utils/numberFormatters";
import { NumericField } from "../positions-and-orders/controls";
import { OptionOrder } from "./types/OptionOrder";
import { MarginAccount } from "./types/MarginAccount";

export function Binance() {
    const {
        getOptionsMarginAccount,
        getOpenOptionOrders,
        sendOptionOrder,
        cancelOptionOrder,
    } = useBinanceOptionsSecuredDataService();
    const [symbol, setSymbol] = useState<string>('BTC-260306-64000-C');
    const [size, setSize] = useState<number>(0.1);
    const [price, setPrice] = useState<number>(10);
    const [orderId, setOrderId] = useState<number>(0);
    
    const [marginAccount, setMarginAccount] = useState<MarginAccount | null>(null);
    const [optionOrder, setOptionOrder] = useState<OptionOrder | null>(null);
    const [openOptionOrders, setOpenOptionOrders] = useState<OptionOrder[] | null>(null);

    // todo: remove
    const handleCreateOptionOrder = async () => {
        const result = await sendOptionOrder(symbol, size, price);
        setOptionOrder(result);
        await handleGetOpenOptionOrders();
    }
    
    const handleGetAccountInfo = async () => {
        const result = await getOptionsMarginAccount();
        setMarginAccount(result);
    }

    const handleGetOpenOptionOrders = async () => {
        const result = await getOpenOptionOrders();
        setOpenOptionOrders(result);
    }

    const handleCancelOrder = async () => {
        const result = await cancelOptionOrder(symbol, orderId);
        await handleGetOpenOptionOrders();
    }

    const numberFormatOptions: Required<NumberFormatOptions> = {
        useGroupFormat: false,
        alwaysUseSign: false
    };
    
    return (
        <>
            <Stack direction="column" spacing={2} sx={{ margin: 1 }}>
                <Button
                    sx={{ fontWeight: "bold" }}
                    size="small"
                    variant="contained"
                    color="primary"
                    onClick={handleGetOpenOptionOrders}
                >
                    Show open option orders
                </Button>
                <pre>
                    {JSON.stringify(openOptionOrders, null, "\t")}
                </pre>
                <Divider sx={{ marginX: 1, marginY: 2 }} />
                <Stack direction="row" spacing={2}  alignItems="top">
                    <TextField
                        margin="normal"
                        id="symbol"
                        name="symbol"
                        label="Symbol"
                        type="string"
                        size="small"
                        defaultValue={symbol}
                        onChange={(arg: React.ChangeEvent<HTMLInputElement>) => setSymbol(arg.target.value)}
                        variant="standard"
                    />
                    <NumericField
                        id="size"
                        name="size"
                        label="Size"
                        value={size}
                        onValueChange={(newValue: number) => setSize(newValue)}
                        formatter={(value: number) => numberFormatters.format3(value, numberFormatOptions)}
                        width={90}
                        step={0.001}
                    />
                    <NumericField
                        id="price"
                        name="price"
                        label="Price"
                        value={price}
                        onValueChange={(newValue: number) => setPrice(newValue)}
                        formatter={(value: number) => numberFormatters.format2(value, numberFormatOptions)}
                        width={90}
                        step={0.01}
                    />
                    <NumericField
                        id="orderId"
                        name="orderId"
                        label="Order ID"
                        value={orderId}
                        onValueChange={(newValue: number) => setOrderId(newValue)}
                        formatter={(value: number) => numberFormatters.format0(value, numberFormatOptions)}
                        width={200}
                        step={0}
                    />
                </Stack>
                <Button
                    sx={{ fontWeight: "bold" }}
                    size="small"
                    variant="contained"
                    color="primary"
                    onClick={handleCreateOptionOrder}
                >
                    Create option order
                </Button>
                <pre>
                    {JSON.stringify(optionOrder, null, "\t")}
                </pre>
                <Divider sx={{ marginX: 1, marginY: 2 }} />
                <Button
                    sx={{ fontWeight: "bold" }}
                    size="small"
                    variant="contained"
                    color="error"
                    onClick={handleCancelOrder}
                >
                    Cancel option order
                </Button>
            </Stack>
            <Divider sx={{ marginX: 1, marginY: 2 }} />
            <Stack direction="column" spacing={2} sx={{ margin: 1 }}>
                <Button
                    sx={{ fontWeight: "bold" }}
                    size="small"
                    variant="contained"
                    color="primary"
                    onClick={handleGetAccountInfo}
                >
                    Show options margin account information
                </Button>
                <pre>
                    {JSON.stringify(marginAccount, null, "\t")}
                </pre>
            </Stack>
        </>
    )
}
